import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const navItems = [
  { to: '/admin', label: 'ADMIN', roles: ['admin'] },
  { to: '/aide-memoire', label: 'AIDE-MÉMOIRE', roles: ['admin', 'editor'] },
  { to: '/meo', label: 'M.E.O.', roles: ['admin', 'editor'] },
  { to: '/', label: 'GRILLE-HORAIRE' },
  { to: '/cue-sheets', label: 'SÉRIES / CUE-SHEETS', roles: ['admin', 'editor'] },
  { to: '/contact-telemag', label: 'CONTACT TELEMAG' },
  { to: '/contact-reseaux', label: 'CONTACT RÉSEAUX CÂBLO', roles: ['admin', 'editor'] },
];

export function Sidebar() {
  const { hasRole, isAuthenticated, user, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleOverlayClick = useCallback(() => {
    setMobileOpen(false);
  }, []);

  return (
    <>
      <button
        type="button"
        className="sidebar-hamburger"
        onClick={() => setMobileOpen((v) => !v)}
        aria-label={mobileOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
      >
        {mobileOpen ? '✕' : '☰'}
      </button>
      {mobileOpen && <div className="sidebar-overlay" onClick={handleOverlayClick} />}
      <aside className={`app-sidebar ${mobileOpen ? 'sidebar-mobile-open' : ''} ${collapsed ? 'sidebar-collapsed' : ''}`}>
        {!collapsed && (
          <>
            <div className="sidebar-logo">
              <img src="/logo.png" alt="Télé Mag" className="sidebar-logo-img" />
            </div>
            <nav className="sidebar-nav">
              {navItems.map((item) => {
                if (item.roles && (!isAuthenticated || !item.roles.some((r) => hasRole(r)))) {
                  return null;
                }
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className={({ isActive }) =>
                      `sidebar-link ${isActive ? 'sidebar-link-active' : ''}`
                    }
                    end={item.to === '/'}
                  >
                    {item.label}
                  </NavLink>
                );
              })}
            </nav>
          </>
        )}
        {isAuthenticated && !collapsed && (
          <div className="sidebar-user-section">
            <span className="sidebar-username">{user?.username}</span>
            <button type="button" className="btn btn-secondary sidebar-logout-btn" onClick={logout}>
              Déconnexion
            </button>
          </div>
        )}
        <button
          type="button"
          className="sidebar-collapse-btn"
          onClick={() => setCollapsed((v) => !v)}
          aria-label={collapsed ? 'Ouvrir le menu' : 'Fermer le menu'}
        >
          {collapsed ? '▶' : '◀'}
        </button>
      </aside>
    </>
  );
}
